
import { Link } from 'react-router-dom';

const FEATURES = [
  {
    icon: 'ri-shield-check-line',
    title: 'QCTO Accredited',
    desc: 'Fully accredited (07-QCTO/SDP090925152814) — your team\'s qualifications are nationally recognised.',
  },
  {
    icon: 'ri-trophy-line',
    title: '15+ Years of Proven Results',
    desc: 'Built on the heritage of Sylman Training Consultancy with an established track record across industries.',
  },
  {
    icon: 'ri-loop-right-line',
    title: 'End-to-End Solutions',
    desc: 'From learnerships and skills programmes to corporate training — a complete lifecycle under one roof.',
  },
];

export default function WhyChooseSection() {
  return (
    <section className="section-wrap bg-white">
      <div className="section-inner">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">

          {/* Image column */}
          <div className="relative reveal-left">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="/why-choose.png"
                alt="Sylman Academy training excellence"
                className="w-full h-[480px] object-cover object-center"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1A3A22]/50 to-transparent" />
            </div>

          </div>

          {/* Content column */}
          <div className="reveal-right">
            <p className="section-label">Why Sylman Academy</p>
            <h2 className="section-heading">
              A Training Partner You Can Count On
            </h2>
            <p className="section-body mb-10">
              We combine rigorous accreditation with deep sector expertise to deliver training that genuinely transforms careers — not just ticks compliance boxes.
            </p>

            <div className="space-y-5 mb-10">
              {FEATURES.map((f, i) => (
                <div key={i} className="flex gap-4 group">
                  <div className="icon-box">
                    <i className={f.icon} />
                  </div>
                  <div>
                    <h3 className="font-sans font-semibold text-[#111111] mb-1 text-sm">{f.title}</h3>
                    <p className="text-[#6b7280] text-sm leading-relaxed">{f.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <Link to="/about">
              <button className="btn btn-primary">
                Learn About Us
                <i className="ri-arrow-right-line ml-2" />
              </button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
